import script from "./MyItemsSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./MyItemsSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./MyItemsSkeleton.vue?vue&type=style&index=0&id=4cabc79f&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cabc79f"]])

export default __exports__